$.fn.toggleClass = function(options){
    var defaults = {
      obj: $(this),
      classToggle: 'active',
      objToggle: $(this).parent(),
      animate: {},
      animateToggle: {},
      callback: () => {}
    }
    var settings = $.extend(defaults, options);
  
    settings.obj.on("click", (e) => {
        e.preventDefault();
        if (settings.objToggle.hasClass(settings.classToggle)) {
            settings.objToggle.removeClass(settings.classToggle);
            settings.objToggle.animate(settings.animateToggle);
        } else {
            settings.objToggle.addClass(settings.classToggle);
            settings.objToggle.animate(settings.animate);
        }
        callback();
    })
}